import { useTranslation } from 'react-i18next';
import { Counter } from '../motion/Counter';
import { Reveal } from '../motion/Reveal';

/** Figma 59:8522 — the monthly-users figure, counting up on arrival. */
export function Stat() {
  const { t } = useTranslation();
  return (
    <Reveal>
      <section className="flex flex-col items-center gap-[12px] text-center font-display leading-[0.9] lg:gap-[26px]">
        <p className="px-[16px] text-center text-[28px] font-medium text-ink sm:text-[40px] lg:whitespace-nowrap lg:px-0 lg:text-[72px]">{t('stat.label')}</p>
        <Counter
          value={t('stat.value')}
          className="whitespace-nowrap text-[56px] font-semibold text-primary tabular-nums sm:text-[80px] lg:text-[144px]"
        />
      </section>
    </Reveal>
  );
}
